import { normalizeFormValue } from '../../hooks/useExtendedFormContext';

import { ErpData } from './ErpData';

export const normalizeErpFormValue = (value: ErpData): ErpData => {
  const normalizedValue = normalizeFormValue(value);

  return {
    ...normalizedValue,
    rtfHeadText: changeHtmlStyle(normalizedValue.rtfHeadText),
    headerTextConverted: changeHtmlStyle(normalizedValue.headerTextConverted),
    rtfFooterText: changeHtmlStyle(normalizedValue.rtfFooterText),
    footerTextConverted: changeHtmlStyle(normalizedValue.footerTextConverted),
  };
};

const changeHtmlStyle = (value: string) => {
  if (!value) {
    return value;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(value, 'text/html');
  const isHTML = Array.from(doc.body.childNodes).some(
    (node) => node.nodeType === Node.ELEMENT_NODE
  );

  if (!isHTML) {
    return value;
  }

  const masterDiv = doc.documentElement.querySelector('body');

  masterDiv.querySelectorAll<HTMLElement>('[style]').forEach((el) => {
    el.style.color = '';
    el.style.fontFamily = 'Arial, sans-serif';
    el.style.fontSize = '10pt';
  });

  return masterDiv.innerHTML;
};
